export const INPUT_ERROR_CLASS = 'campaign-setup__input-error';
